//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { RQ } from 'utils';
import PullTo from 'vue-pull-to';
import isEmpty from 'lodash/isEmpty';
import loadingView from '../loading-view';
import errorView from '../error-view';
import emptyView from '../empty-view';

export default {
  name: 'y-list',
  components: {
    PullTo, loadingView, errorView, emptyView
  },
  props: {
    /*是否自动加载*/
    autoRefresh: {
      type: Boolean,
      default: true
    },
    /*是否下拉, 默认true*/
    pullRefresh: {
      type: Boolean,
      default: true
    },
    /*是否分页, 默认true*/
    loadMore: {
      type: Boolean,
      default: true
    },
    fetchData: Function,
    wrapperHeight: {
      type: String,
      default: '100%'
    },
    pageData: {
      type: Object
    },
    isLoading: {
      type: Boolean
    },
    emptyData: {
      type: Object
    }
  },
  data() {
    return {
      page: 0,
      total: undefined,
      pullTopState: undefined,
      loadMoreState: undefined,
      listData: undefined,
      iconLink: undefined,
      displayStatus: {
        loading: '加载中...',
        fail: '加载失败~',
        done: '已经没有更多了'
      }
    };
  },
  created: async function () {
    this.autoRefresh && this.loadData(1);
  },
  computed: {
    isFirstLoading () {
      const pageData = this.pageData;
      return !pageData || pageData.code === undefined
    },
    isEmpty() {
      const pageData = this.pageData;
      return pageData && pageData.code == 0 && pageData.data.pageData && pageData.data.pageData.length == 0
    },
    isError() {
      const pageData = this.pageData;
      return pageData && pageData.code !== undefined && pageData.code !== 0
    },
    noMore() {
      const pageData = this.pageData;
      return !this.isEmpty && !this.isError && pageData && pageData.data && pageData.data.pageData.length === pageData.data.total
    }
  },
  methods: {
    async loadData(page, loaded) {
      const res = await this.fetchData(page);
      if (res.code === 0) {
        loaded && loaded('done');
      } else {
        loaded && loaded('fail');
      }
      console.log('-------this', this)
      // if (res && res.code == 0) {
      //   const data = res.data;
      //   const list = this.listData || [];
      //   this.listData = list.concat(data.pageData);
      //   this.totalCount = data.total;
      //   this.page = data.page;
      //   if (page > 1) {
      //     if (this.listData.length >= this.totalCount) {
      //       this.loadMoreState = 'done';
      //     } else {
      //       this.loadMoreState = 'success';
      //     }
      //   }
      //   // loaded && loaded('done');
      // } else {
      //   // loaded && loaded('fail');
      //   if (page > 1) {
      //     this.loadMoreState = 'fail';
      //   }
      // }
      // this.$emit('changedList', {
      //   items: this.listData,
      //   isError: res.code == 0,
      //   isEmpty: isEmpty(this.listData),
      //   page: this.page
      // });
    },
    handlePullRefresh(loaded) {
      this.listData = [];//初始化置空数据
      this.loadData(1, loaded);
    },
    handleLoadMore() {
      // console.log(this.pullTopState, this.loadMoreState);
      // if (this.loadMoreState == undefined || this.loadMoreState != 'loading') {
      //   this.loadMoreState = 'loading';
      //
      //   this.loadData(this.page + 1);
      // }
      this.loadData(this.page + 1);
    },

    handleChangedState(state) {
      switch (state) {
        case 'pull':
        case 'trigger':
          this.iconLink = '#icon-arrow-bottom';
          break;
        case 'loading':
          this.iconLink = '#icon-loading';
          break;
        case 'loaded-done':
        case 'fail':
          this.iconLink = undefined;
      }
      this.pullTopState = state;
    },
    search: async function () {
      this.loadData(1);
    },
    handleScroll(e) {
      console.log('e---------> ', e);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/app/list/index.vue